import React, { useMemo, useState } from 'react';
import { Box, Card, CardContent, Typography, Button, TextField, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import dayjs from 'dayjs';
import { useTenant } from '../components/ContextTenant.tsx';
import { toastError, toastSuccess } from '../shared/ui/toast.ts';
import { getOverview, downloadOverviewCsv, downloadTopHoursCsv, downloadTopJobTitlesCsv } from '../services/metrics.ts';

const ReportsPage: React.FC = () => {
  const { tenantId } = useTenant();
  const [from, setFrom] = useState(dayjs().startOf('week').format('YYYY-MM-DD'));
  const [to, setTo] = useState(dayjs().endOf('week').format('YYYY-MM-DD'));
  const [report, setReport] = useState<'overview'|'top_hours'|'top_job_titles'>('overview');

  const exportCsv = async () => {
    try {
      let blob: Blob;
      let name = 'report';
      if (report === 'overview') {
        blob = await downloadOverviewCsv(from, to);
        name = 'overview';
      } else if (report === 'top_hours') {
        blob = await downloadTopHoursCsv(from, to);
        name = 'top_hours';
      } else {
        blob = await downloadTopJobTitlesCsv();
        name = 'top_job_titles';
      }
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      const ts = dayjs().format('YYYYMMDD_HHmm');
      a.href = url; a.download = `${name}_${from}_to_${to}_${ts}.csv`; a.click(); URL.revokeObjectURL(url);
      toastSuccess('CSV exportat');
    } catch (e:any) {
      toastError(e?.message || 'Export eșuat');
    }
  };

  return (
    <Box p={2}>
      <Typography variant="h5" sx={{ mb: 2 }}>Rapoarte</Typography>
      <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
        <CardContent>
          <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
            <FormControl>
              <InputLabel id="report-type">Tip raport</InputLabel>
              <Select labelId="report-type" value={report} label="Tip raport" onChange={(e)=> setReport(e.target.value as any)} size="small" sx={{ minWidth: 220 }}>
                {/* <MenuItem value="overview">Overview KPI</MenuItem> */}
                <MenuItem value="top_hours">Top Hours</MenuItem>
                <MenuItem value="top_job_titles">Top HR Functions</MenuItem>
              </Select>
            </FormControl>
            <TextField size="small" type="date" label="De la" value={from} onChange={(e)=> setFrom(e.target.value)} />
            <TextField size="small" type="date" label="Până la" value={to} onChange={(e)=> setTo(e.target.value)} />
            <Button variant="contained" onClick={exportCsv}>Exportă CSV</Button>
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ display:'block', mt: 1 }}>
            Export CSV include intervalul selectat. Pentru Top Job Titles, intervalul nu se aplică (agregat curent).
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReportsPage;


